import { render, staticRenderFns } from "./ImportantMessage.vue?vue&type=template&id=0ab504bc&scoped=true"
import script from "./ImportantMessage.vue?vue&type=script&lang=js"
export * from "./ImportantMessage.vue?vue&type=script&lang=js"
import style0 from "./ImportantMessage.vue?vue&type=style&index=0&id=0ab504bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab504bc",
  null
  
)

export default component.exports